import React from 'react';

// const carList = [
 
 
//  {
//   images: ['/images/fleet/Aura.jpg'],
//   brand: 'Hyundai',
//   available: true,
//   location: 'India',
//   title: 'Hyundai Aura',
//   rating: 5.0,
//   reviews: 100,
//   price: 40,
//   details: [],
// },
// {
//   images: ['/images/fleet/Honda-City.jpg'],
//   brand: 'Honda',
//   available: true,
//   location: 'India',
//   title: 'Honda City',
//   rating: 5.0,
//   reviews: 100,
//   price: 55,
//   details: [],
// },
// {
//   images: ['/images/fleet/Hycross.jpg'],
//   brand: 'Toyota',
//   available: true,
//   location: 'India',
//   title: 'Toyota Hycross',
//   rating: 5.0,
//   reviews: 100,
//   price: 90,
//   details: [],
// },
// {
//   images: ['/images/fleet/kia-carens.jpg'],
//   brand: 'Kia',
//   available: true,
//   location: 'India',
//   title: 'Kia Carens',
//   rating: 5.0,
//   reviews: 100,
//   price: 65,
//   details: [],
// },
// {
//   images: ['/images/fleet/Toyota-Rumoin.jpg'],
//   brand: 'Toyota',
//   available: true,
//   location: 'India',
//   title: 'Toyota Rumion',
//   rating: 5.0,
//   reviews: 100,
//   price: 60,
//   details: [],
// },
// {
//   images: ['/images/fleet/13-seater-tempo-traveller.jpg'],
//   brand: 'Tempo Traveller',
//   available: true,
//   location: 'India',
//   title: '13 Seater Tempo Traveller',
//   rating: 5.0,
//   reviews: 100,
//   price: 120,
//   details: [],
// },
// {
//   images: ['/images/fleet/20-seater-tempo-traveller.jpg'],
//   brand: 'Tempo Traveller',
//   available: true,
//   location: 'India',
//   title: '20 Seater Tempo Traveller',
//   rating: 5.0,
//   reviews: 100,
//   price: 150,
//   details: [],
// },
//   {
//     images: ['/images/fleet/Maruti-swift-Dzire.jpg'],
//     brand: 'Maruti',
//     available: true,
//     location: 'India',
//     title: 'Maruti Swift Dzire',
//     rating: 5.0,
//     reviews: 100,
//     price: 40,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Honda-Amaze.jpg'],
//     brand: 'Honda',
//     available: true,
//     location: 'India',
//     title: 'Honda Amaze',
//     rating: 5.0,
//     reviews: 100,
//     price: 45,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Toyota-Etios.jpg'],
//     brand: 'Toyota',
//     available: true,
//     location: 'India',
//     title: 'Toyota Etios',
//     rating: 5.0,
//     reviews: 100,
//     price: 45,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Toyota-corolla-Altis.jpg'],
//     brand: 'Toyota',
//     available: true,
//     location: 'India',
//     title: 'Toyota Corolla Altis',
//     rating: 5.0,
//     reviews: 100,
//     price: 55,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Maruti-Ertiga.jpg'],
//     brand: 'Maruti',
//     available: true,
//     location: 'India',
//     title: 'Maruti Ertiga',
//     rating: 5.0,
//     reviews: 100,
//     price: 60,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Toyota-Innova.jpg'],
//     brand: 'Toyota',
//     available: true,
//     location: 'India',
//     title: 'Toyota Innova',
//     rating: 5.0,
//     reviews: 100,
//     price: 70,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Innova-Crysta.jpg'],
//     brand: 'Toyota',
//     available: true,
//     location: 'India',
//     title: 'Innova Crysta',
//     rating: 5.0,
//     reviews: 100,
//     price: 80,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Tavera.jpg'],
//     brand: 'Chevrolet',
//     available: true,
//     location: 'India',
//     title: 'Tavera',
//     rating: 5.0,
//     reviews: 100,
//     price: 75,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/Scorpio.jpg'],
//     brand: 'Mahindra',
//     available: true,
//     location: 'India',
//     title: 'Scorpio',
//     rating: 5.0,
//     reviews: 100,
//     price: 85,
//     details: [],
//   },
//   {
//     images: ['/images/fleet/mini-bus.jpg'],
//     brand: 'Mini Bus',
//     available: true,
//     location: 'India',
//     title: 'Mini Bus',
//     rating: 5.0,
//     reviews: 100,
//     price: 120,
//     details: [],
//   },
// ];


const carList = [

  // 🚗 Sedan
  { images: ['/images/fleet/Aura.jpg'], brand: 'Hyundai', available: true, location: 'India', title: 'Hyundai Aura', rating: 4.7, reviews: 100, price: 40, details: [] },
  { images: ['/images/fleet/Maruti-swift-Dzire.jpg'], brand: 'Maruti', available: true, location: 'India', title: 'Maruti Swift Dzire', rating: 5.0, reviews: 100, price: 40, details: [] },
  { images: ['/images/fleet/Honda-Amaze.jpg'], brand: 'Honda', available: true, location: 'India', title: 'Honda Amaze', rating: 4.8, reviews: 100, price: 45, details: [] },
  { images: ['/images/fleet/Toyota-Etios.jpg'], brand: 'Toyota', available: true, location: 'India', title: 'Toyota Etios', rating: 5.0, reviews: 100, price: 45, details: [] },
  { images: ['/images/fleet/Honda-City.jpg'], brand: 'Honda', available: true, location: 'India', title: 'Honda City', rating: 4.9, reviews: 100, price: 55, details: [] },
  { images: ['/images/fleet/Toyota-corolla-Altis.jpg'], brand: 'Toyota', available: true, location: 'India', title: 'Toyota Corolla Altis', rating: 5.0, reviews: 100, price: 55, details: [] },

  // 🚙 SUV
  { images: ['/images/fleet/Scorpio.jpg'], brand: 'Mahindra', available: true, location: 'India', title: 'Scorpio', rating: 5.0, reviews: 100, price: 85, details: [] },

  // 🚐 MUV
  { images: ['/images/fleet/Maruti-Ertiga.jpg'], brand: 'Maruti', available: true, location: 'India', title: 'Maruti Ertiga', rating: 4.6, reviews: 100, price: 60, details: [] },
  { images: ['/images/fleet/Toyota-Rumoin.jpg'], brand: 'Toyota', available: true, location: 'India', title: 'Toyota Rumion', rating: 5.0, reviews: 100, price: 60, details: [] },
  { images: ['/images/fleet/kia-carens.jpg'], brand: 'Kia', available: true, location: 'India', title: 'Kia Carens', rating: 5.0, reviews: 100, price: 65, details: [] },
  { images: ['/images/fleet/Tavera.jpg'], brand: 'Chevrolet', available: true, location: 'India', title: 'Tavera', rating: 5.0, reviews: 100, price: 75, details: [] },
  { images: ['/images/fleet/Toyota-Innova.jpg'], brand: 'Toyota', available: true, location: 'India', title: 'Toyota Innova', rating: 4.8, reviews: 100, price: 70, details: [] },
  { images: ['/images/fleet/Innova-Crysta.jpg'], brand: 'Toyota', available: true, location: 'India', title: 'Innova Crysta', rating: 5.0, reviews: 100, price: 80, details: [] },
  { images: ['/images/fleet/Hycross.jpg'], brand: 'Toyota', available: true, location: 'India', title: 'Toyota Hycross', rating: 4.9, reviews: 100, price: 90, details: [] },

  // 🚐 Traveller
  { images: ['/images/fleet/13-seater-tempo-traveller.jpg'], brand: 'Tempo Traveller', available: true, location: 'India', title: '13 Seater Tempo Traveller', rating: 5.0, reviews: 100, price: 120, details: [] },
  { images: ['/images/fleet/20-seater-tempo-traveller.jpg'], brand: 'Tempo Traveller', available: true, location: 'India', title: '20 Seater Tempo Traveller', rating: 5.0, reviews: 100, price: 150, details: [] },

  // 🚌 Bus
  { images: ['/images/fleet/mini-bus.jpg'], brand: 'Mini Bus', available: true, location: 'India', title: 'Mini Bus', rating: 5.0, reviews: 100, price: 120, details: [] },

];
const Ourfleets = () => {
  return (
  <>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Our Fleets</h2>
           
          </div>
        </div>
      </div>
    </div>


  
    <section className="car-section">
      <div className="container">
        <div className="row">
          {carList.map((car, idx) => (
            <div key={idx} className="col-lg-4 col-md-6">
              <div className="listing-item listing-item-two">
                <div className="listing-img">
                  {car.images.length > 1 ? (
                    <div className="img-slider">
                      {car.images.map((img, i) => (
                        <div key={i} className="slide-images">
                          
                        </div>
                      ))}
                    </div>
                  ) : (
                    <a>
                      <img src={car.images[0]} className="img-fluid" alt={car.brand} />
                    </a>
                  )}

                  <div className="fav-item">
                    <div className="d-flex align-items-center gap-2">
                      <span className="featured-text">{car.brand}</span>
                      <span className="availability">{car.available ? 'Available' : 'Unavailable'}</span>
                    </div>
                    <a href="javascript:void(0)" className="fav-icon selected">
                      <i className="feather-heart"></i>
                    </a>
                  </div>

                  <span className="location">
                    <i className="bx bx-map me-1"></i>
                    {car.location}
                  </span>
                </div>

                <div className="listing-content">
                  <div className="listing-features d-flex align-items-center justify-content-between">
                    <div className="list-rating">
                     
                      <div className="list-rating">
                        {Array.from({ length: 5 }, (_, i) => (
                          <i
                            key={i}
                            className={`fas fa-star ${i < Math.floor(car.rating) ? 'filled' : ''}`}
                          ></i>
                        ))}
                        <span>({car.rating}) {car.reviews} Reviews</span>
                      </div>
                    </div>
                  
                  </div>
  <h5 className='text-center'>{car.title}</h5>
                  <div className="listing-details-group">
                    <ul>
                      {car.details.map((d, i) => (
                        <li key={i}>
                          <img src={d.icon} alt={d.label} />
                          <p>{d.label}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  
  </>
  );
};

export default Ourfleets;